import { Environment } from '@app/core/environment';

export const environment: Environment = {
    production: false,
    apiUrl: 'https://tassullo-offertool.testing.zupit.software/api',
    logging: {
        connectionString: '',
        appName: 'frontend',
    },
    auth: {
        redirectUri: 'https://tassullo-offertool.testing.zupit.software',
        issuer: 'https://keycloak.zupit.software/realms/tassullo-offertool-testing',
        clientId: 'oidc',
        showDebugInformation: true,
    },
    version: '',
    clarityProjectId: '',
};
